var Afghanistan = "Afghanistan";
var Albania = "Albania";
var Algeria = "Algeria";
var Andorra = "Andorra";
var Angola = "Angola";
var Anguilla = "Anguilla";
var Antarctica = "Antartide";
var Argentina = "Argentina";
var Armenia = "Armenia";
var Aruba = "Aruba";
var Australia = "Australia";
var Austria = "Austria";
var Azerbaijan = "Azerbaigian";
var Bahamas = "Bahamas";
var Bahrain = "Bahrein";
var Bangladesh = "Bangladesh";
var Barbados = "Barbados";
var Belarus = "Bielorussia";
var Belgium = "Belgio";
var Belize = "Belize";
var Benin = "Benin";
var Bermuda = "Bermuda";
var Bhutan = "Bhutan";
var Bolivia = "Bolivia";
var Botswana = "Botswana";
var Brazil = "Brasile";
var Bulgaria = "Bulgaria";
var Burundi = "Burundi";
var Cambodia = "Cambogia";
var Cameroon = "Camerun";
var Canada = "Canada";
var Chad = "Ciad";
var Chile = "Cile";
var China = "Cina";
var Colombia = "Colombia";
var Comoros = "Comore";
var Congo = "Congo";
var Croatia = "Croazia";
var Cuba = "Cuba";
var Cyprus = "Cipro";
var Denmark = "Danimarca";
var Djibouti = "Gibuti";
var Dominica = "Dominica";
var Ecuador = "Ecuador";
var Egypt = "Egitto";
var Eritrea = "Eritrea";
var Estonia = "Estonia";
var Ethiopia = "Etiopia";
var Fiji = "Figi";
var Finland = "Finlandia";
var France = "Francia";
var Gabon = "Gabon";
var Gambia = "Gambia";
var Georgia = "Georgia";
var Germany = "Germania";
var Ghana = "Ghana";
var Gibraltar = "Gibilterra";
var Greece = "Grecia";
var Greenland = "Groenlandia";
var Grenada = "Grenada";
var Guadeloupe = "Guadalupa";
var Guam = "Guam";
var Guatemala = "Guatemala";
var Guernsey = "Guernsey";
var Guinea = "Guinea";
var Guyana = "Guyana";
var Haiti = "Haiti";
var Honduras = "Honduras";
var Hungary = "Ungheria";
var Iceland = "Islanda";
var India = "India";
var Indonesia = "Indonesia";
var Iraq = "Iraq";
var Ireland = "Irlanda";
var Israel = "Israele";
var Italy = "Italia";
var Jamaica = "Giamaica";
var Japan = "Giappone";
var Jersey = "Jersey";
var Jordan = "Giordania";
var Kazakhstan = "Kazakistan";
var Kenya = "Kenya";
var Kiribati = "Kiribati";
var Kuwait = "Kuwait";
var Kyrgyzstan = "Kirghizistan";
var Latvia = "Lettonia";
var Lebanon = "Libano";
var Lesotho = "Lesotho";
var Liberia = "Liberia";
var Libya = "Libia";
var Liechtenstein = "Liechtenstein";
var Lithuania = "Lituania";
var Luxembourg = "Lussemburgo";
var Macao = "Macao";
var Madagascar = "Madagascar";
var Malawi = "Malawi";
var Malaysia = "Malesia";
var Maldives = "Maldive";
var Mali = "Mali";
var Malta = "Malta";
var Martinique = "Martinica";
var Mauritania = "Mauritania";
var Mauritius = "Mauritius";
var Mayotte = "Mayotte";
var Mexico = "Messico";
var Monaco = "Principato di Monaco";
var Mongolia = "Mongolia";
var Montenegro = "Montenegro";
var Montserrat = "Montserrat";
var Morocco = "Marocco";
var Mozambique = "Mozambico";
var Myanmar = "Myanmar";
var Namibia = "Namibia";
var Nauru = "Nauru";
var Nepal = "Nepal";
var Netherlands = "Paesi Bassi";
var Nicaragua = "Nicaragua";
var Niger = "Niger";
var Nigeria = "Nigeria";
var Niue = "Niue";
var Norway = "Norvegia";
var Oman = "Oman";
var Pakistan = "Pakistan";
var Palau = "Palau";
var Panama = "Panama";
var Paraguay = "Paraguay";
var Peru = "Perù";
var Philippines = "Filippine";
var Pitcairn = "Pitcairn";
var Poland = "Polonia";
var Portugal = "Portogallo";
var Qatar = "Qatar";
var Romania = "Romania";
var Rwanda = "Ruanda";
var Samoa = "Samoa";
var Senegal = "Senegal";
var Serbia = "Serbia";
var Seychelles = "Seychelles";
var Singapore = "Singapore";
var Slovakia = "Slovacchia";
var Slovenia = "Slovenia";
var Somalia = "Somalia";
var Spain = "Spagna";
var Sudan = "Sudan";
var Suriname = "Suriname";
var Swaziland = "eSwatini";
var Sweden = "Svezia";
var Switzerland = "Svizzera";
var Taiwan = "Taiwan";
var Tajikistan = "Tagikistan";
var Thailand = "Thailandia";
var Togo = "Togo";
var Tokelau = "Tokelau";
var Tonga = "Tonga";
var Tunisia = "Tunisia";
var Turkey = "Turchia";
var Turkmenistan = "Turkmenistan";
var Tuvalu = "Tuvalu";
var Uganda = "Uganda";
var Ukraine = "Ucraina";
var Uruguay = "Uruguay";
var Uzbekistan = "Uzbekistan";
var Vanuatu = "Vanuatu";
var Venezuela = "Venezuela";
var Yemen = "Yemen";
var Zambia = "Zambia";
var Zimbabwe = "Zimbabwe";
var countries = {
	"Country or region": "Paese o regione",
	"United States": "Stati Uniti",
	Afghanistan: Afghanistan,
	"Åland Islands": "Isole Åland",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "Samoa Americane",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "Antigua e Barbuda",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "Bosnia ed Erzegovina",
	Botswana: Botswana,
	"Bouvet Island": "Isola Bouvet",
	Brazil: Brazil,
	"British Indian Ocean Territory": "Territorio Britannico dell’Oceano Indiano",
	"Brunei Darussalam": "Brunei Darussalam",
	Bulgaria: Bulgaria,
	"Burkina Faso": "Burkina Faso",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "Capo Verde",
	"Cayman Islands": "Isole Cayman",
	"Central African Republic": "Repubblica Centrafricana",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "Isola di Natale",
	"Cocos (Keeling) Islands": "Isole Cocos (Keeling)",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "Repubblica Democratica del Congo",
	"Cook Islands": "Isole Cook",
	"Costa Rica": "Costa Rica",
	"Côte d'Ivoire": "Costa d'Avorio",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "Repubblica Ceca",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "Repubblica Dominicana",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "El Salvador",
	"Equatorial Guinea": "Guinea Equatoriale",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "Isole Falkland (Malvinas)",
	"Faroe Islands": "Isole Faroe",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "Guyana Francese",
	"French Polynesia": "Polinesia Francese",
	"French Southern Territories": "Territori Francesi Meridionali",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "Guinea-Bissau",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "Isola Heard e Isole McDonald",
	"Holy See (Vatican City State)": "Santa Sede (Città del Vaticano)",
	Honduras: Honduras,
	"Hong Kong": "Hong Kong",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "Repubblica Islamica dell'Iran",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "Isola di Man",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "Repubblica Popolare Democratica di Corea",
	"Korea, Republic of": "Repubblica di Corea",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "Repubblica Popolare Democratica del Laos",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "Ex Repubblica Jugoslava di Macedonia",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "Isole Marshall",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "Stati Federati di Micronesia",
	"Moldova, Republic of": "Repubblica di Moldavia",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "Antille Olandesi",
	"New Caledonia": "Nuova Caledonia",
	"New Zealand": "Nuova Zelanda",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "Isola Norfolk",
	"Northern Mariana Islands": "Isole Marianne Settentrionali",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "Territori Palestinesi Occupati",
	Panama: Panama,
	"Papua New Guinea": "Papua Nuova Guinea",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "Porto Rico",
	Qatar: Qatar,
	"Réunion": "La Riunione",
	Romania: Romania,
	"Russian Federation": "Federazione Russa",
	Rwanda: Rwanda,
	"Saint Helena": "Sant’Elena",
	"Saint Kitts and Nevis": "Saint Kitts e Nevis",
	"Saint Lucia": "Santa Lucia",
	"Saint Pierre and Miquelon": "Saint Pierre e Miquelon",
	"Saint Vincent and The Grenadines": "Saint Vincent e Grenadine",
	Samoa: Samoa,
	"San Marino": "San Marino",
	"Sao Tome and Principe": "São Tomé e Príncipe",
	"Saudi Arabia": "Arabia Saudita",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "Sierra Leone",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "Isole Salomone",
	Somalia: Somalia,
	"South Africa": "Sudafrica",
	"South Georgia and The South Sandwich Islands": "Georgia del Sud e Isole Sandwich Australi",
	Spain: Spain,
	"Sri Lanka": "Sri Lanka",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "Svalbard e Jan Mayen",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "Repubblica Araba di Siria",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "Repubblica Unita di Tanzania",
	Thailand: Thailand,
	"Timor-Leste": "Timor Est",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "Trinidad e Tobago",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "Isole Turks e Caicos",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "Emirati Arabi Uniti",
	"United Kingdom": "Regno Unito",
	"United States Minor Outlying Islands": "Isole Minori Esterne degli Stati Uniti",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "Vietnam",
	"Virgin Islands, British": "Isole Vergini Britanniche",
	"Virgin Islands, U.S.": "Isole Vergini Americane",
	"Wallis and Futuna": "Wallis e Futuna",
	"Western Sahara": "Sahara Occidentale",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
